<mat-form-field class="w-100">
  <mat-label>{{ label }}</mat-label>
  <input matInput maxlength="100" autocomplete="a-random-string" [formControl]="itemControl" [matAutocomplete]="auto"
    (focus)="onFocus()" (focus)="onFocus()" (keyup)="onKeyUp($event)" (blur)="onBlur()">
  <mat-autocomplete [displayWith]="getDisplayName" (optionSelected)="onItemSelected($event)" #auto="matAutocomplete">
    @for (option of filteredItems | async; track getItemId(option)) {
    <mat-option [value]="option">
      {{ getItemName(option) }}
    </mat-option>
    @if(showDivider(option)) {
    <mat-divider></mat-divider>
    }
    }
  </mat-autocomplete>
  @if (!itemControl.disabled) {
  <span matSuffix class="suffix-container">
    <button mat-icon-button color="primary" type="button" (click)="onRemoveSelectedItem()">
      <mat-icon>clear</mat-icon>
    </button>
    @if (infoText) {
    <mat-icon class="me-2" color="primary" [matTooltip]="infoText">info</mat-icon>
    }
  </span>
  }
  @for(error of errors; track error) {
  <mat-error>{{ error }}</mat-error>
  }

  @if (hasError(itemControl, 'required')) {
  <mat-error>{{ 'Common.Validation.Required' | translate }}</mat-error>
  }

</mat-form-field>